import React from 'react';

import { forwardRef, Heading as ChakraHeading } from '@chakra-ui/react';

import { defaultSpacing21 } from '../../default-spacing';
import { HeadingSize21, HeadingV21Props } from '../../types';
import { getSpacingProps } from '../../utils';

const DEFAULT_SIZE: HeadingSize21 = 'title-md';

/**
 * DLS 2.1 (legacy) Heading — the t-shirt scale, unchanged.
 *
 * `data-dls-version="2.1"` is what the themes' `versionedStyleConfig` keys off to resolve the
 * 2.1 styles; the dispatcher passes it. Per-version defaults are passed as props, because the
 * merged style-config's `defaultProps` come from the current (2.2) version.
 */
export const HeadingV21 = forwardRef<HeadingV21Props, 'h2'>((props, ref) => {
  const { noDefaultSpacing = false, size = DEFAULT_SIZE, ...rest } = props;

  const spacingProps = noDefaultSpacing
    ? {}
    : getSpacingProps(size, defaultSpacing21);

  return <ChakraHeading ref={ref} size={size} {...spacingProps} {...rest} />;
});

HeadingV21.displayName = 'Heading';
